import { Button, Form, Modal, Panel } from 'react-bulma-components';
import React, { useState } from 'react';

import { Loader } from '.';
import _ from 'lodash';
import axios from 'axios';
import { faMusic } from '@fortawesome/free-solid-svg-icons';
import { filesize } from "filesize";
import { useGlobalModalContext } from "../hooks/globalModal";

const { InputFile } = Form;

const MediaUploadModal = ({ }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  function handleFileSelect(filename) {

  }
  const { hideModal, store } = useGlobalModalContext();
  const { modalProps } = store || {};
  const { title, path, confirmBtn, createPreviousModalFunction } = modalProps || {};


  const handleModalToggle = () => {
    createPreviousModalFunction();
    //hideModal();
  };

  const handleInputFileChange = (event => {
    setFiles(Array.from(event.target.files));
  });

  const removeFileFromList = (index => {
    let filesArr = [...files];
    filesArr.splice(index, 1);
    setFiles(filesArr);
  });

  const handleUploadFiles = () => {
    setUploading(true);
    setMessage('Uploading files ...');
    const data = new FormData();
    data.append('path', path);
    for (var x = 0; x < files.length; x++) {
      data.append('file', files[x]);
    }

    axios.post(`${process.env.REACT_APP_API_URL}/media`, data, {
    })
      .then(res => {
        setMessage('');
        setUploading(false);
        let filesArr = [...files];
        res.data.forEach(uploadresult => {
          let file = _.find(filesArr, function(f) { return path+'/'+f.name === uploadresult.filename; });
          if(file){
            file.uploadmessage= uploadresult.message;
            file.uploadstatus = uploadresult.success;
          }
        });
        setFiles(filesArr);
/*         

        let uploaded = _.filter(res.data, function(file) { 
          return file.success === true; 
       });
       let trimmed = _.map(uploaded, 'filename');
       let mess = trimmed.join("/n/r");
       setMessage('Uploaded '+mess); */
      console.log(res.statusText)
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(error.response.data.error);
        }
      })
  }

  return (
    <Modal show={true}
      onClose={handleModalToggle}>
      <Modal.Card>
        <Modal.Card.Header showClose={true}>
          <Modal.Card.Title>
            {title || "Upload Modal"}
          </Modal.Card.Title>
        </Modal.Card.Header>
        <Modal.Card.Body>
          <InputFile
            inputProps={{ multiple: true }}
            onChange={handleInputFileChange}
            label="Choose files ..."
          />
          <Panel>

            {files &&
              files.map((file, index) =>
              {
                let fileBgColor = '';
                if(file.uploadstatus === true){ fileBgColor = '#dcfce2'}
                if(file.uploadstatus === false){ fileBgColor = '#fcdcdc'}
                return(
                <Panel.Block
                  key={index}
                  active={file.name === 'dummy' ? true : false}
                  renderAs="a"
                  style={{ backgroundColor: fileBgColor}}
                //onClick={() => handleFileSelect(file.filename)}
                >
                  <Panel.Icon>
                    <Button remove onClick={() => removeFileFromList(index)} />
                  </Panel.Icon>
                  {file.name} <span style={{ position: 'relative', color: '#999', paddingLeft: '0.5rem' }}>{filesize(file.size)}</span> 
                  <span style={{ position: 'relative', paddingLeft: '0.5rem' }}><i>{file.uploadmessage || ''}</i></span>

                </Panel.Block>
                )
              }
              )

            }
          </Panel>
          <p>{message}</p>

        </Modal.Card.Body>
        <Modal.Card.Footer style={{ alignItems: 'center', justifyContent: 'center' }}>
          <p>
            <Button onClick={handleModalToggle}>Close</Button>
          </p>
          {/*           <p>
            <Button onClick={handleInsertPath}>Insert path</Button>
          </p> */}
          <p>
            <Button onClick={handleUploadFiles} disabled={(files?.length > 0 ? false : true) || uploading}>{uploading ? <Loader theSize={32}  mt={0}/> : 'Upload'}</Button>
          </p>
        </Modal.Card.Footer>
      </Modal.Card>
    </Modal>
  )
}

export default MediaUploadModal;